/**
 * Environment variables from `tmr-env.json` are added as {@link ngConstant constants} passed
 * in by webpack EnvironmentPlugin plugin on the variable process.env.tmrEnv
 *
 * `tmrApiProtocol`, `tmrApiBasePath` and `tmrApiPrefix` can be overridden by environment
 * by passing the variable `BACKEND_URL`. (tmrApiPrefix is handled in apiPrefix)
 *
 * @example
 *   # BACKEND_URL=https:/www.example.com/tmr-api-foo npm run build
 * (override is also used by special webpack configurations like devServer proxy)
 *
 * @name Environment constants
 */
const constants = [
  ['tmrApiProtocol', process.env.tmrEnv.tmrApiProtocol],
  ['tmrApiBasePath', process.env.tmrEnv.tmrApiBasePath],
  ['tmrBasePath', process.env.tmrEnv.tmrBasePath],
  ['tmrRouterHtml5Mode', process.env.tmrEnv.tmrRouterHtml5Mode],
  ['tmrDemo', process.env.tmrEnv.tmrDemo],
]

export { constants }
